import { render } from "./MentoringDialog.vue?vue&type=template&id=1daf6ec2"
import script from "./MentoringDialog.vue?vue&type=script&lang=js"
export * from "./MentoringDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__